const types = {
  SET_LOADING: 'SET_LOADING', // 加载状态
  LOOK_PROTOCOL: 'LOOK_PROTOCOL', // 查看协议
  NO_QUESTION: 'NO_QUESTION', // 是否有问题
  UPDATE_QUESTION: 'UPDATE_QUESTION', // 更新问题
  UPDATE_QUESTION_STATUS: 'UPDATE_QUESTION_STATUS', // 更新问题状态
  UPDATE_NAV: 'UPDATE_NAV', // 更新顶部导航
  DOCTOR_DETAIL: 'DOCTOR_DETAIL', // 医生详情
  QUESTION_LIST: 'QUESTION_LIST', // 我的服务列表
  INTERROGATION_ID: 'INTERROGATION_ID', // 问诊ID
  IS_RATE: 'IS_RATE', // 是否评价
  SET_PRICE: 'SET_PRICE', // 设置全局价格
  SET_BANNERURL: 'SET_BANNERURL', // 设置banner
  SET_ONLINETIME: 'SET_ONLINETIME', // 设置在线时间
  SET_NEWMESSAGE: 'SET_NEWMESSAGE', // 设置新消息状态
  SET_TOKEN: 'SET_TOKEN', // 设置token
  GET_CONSTANT_DATA: 'GET_CONSTANT_DATA', // 获取后台设置的静态数据
  MEMBER_STATE: 'MEMBER_STATE', // 会员状态
  GOODS_VIP_INFO: 'GOODS_VIP_INFO' // 产品的vip信息
};

export default types;



// WEBPACK FOOTER //
// ./src/stores/mutation-types.js